import { z } from 'zod'

/**
 * 배송 사진 API 계약 (BIZ-12, 설계 명세서 7장).
 *
 * 응답에는 **서명 URL만** 담는다. S3 오브젝트 키·원본 URL은 밖으로 내보내지 않는다.
 * 서명 URL은 만료되므로, 링크가 새어도 곧 못 쓰게 된다(공개 버킷 아님).
 */

/** 한 장의 사진. 표시용·썸네일 서명 URL과 공개 여부만 노출한다. */
export const photoView = z.object({
  id: z.number().int(),
  displayUrl: z.string(),
  thumbUrl: z.string(),
  /** 기업에게 공개되는 사진인지(기획 11.5). 업체·운영자는 무관하게 다 본다. */
  isPublic: z.boolean(),
  createdAt: z.string(),
})
export type PhotoView = z.infer<typeof photoView>

export const photoListResponse = z.object({ photos: z.array(photoView) })
export type PhotoListResponse = z.infer<typeof photoListResponse>

export const photoUploadResponse = z.object({ photo: photoView })
export type PhotoUploadResponse = z.infer<typeof photoUploadResponse>

export const PhotoErrorCode = {
  ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
  PHOTO_NOT_FOUND: 'PHOTO_NOT_FOUND', // 그 주문에 해당 사진이 없음(삭제)
  FORBIDDEN: 'FORBIDDEN',
  NOT_UPLOADABLE: 'NOT_UPLOADABLE', // 배송 단계가 아니라 사진을 올리거나 지울 수 없음
  NO_FILE: 'NO_FILE', // multipart에 파일이 없음
  UNSUPPORTED_IMAGE: 'UNSUPPORTED_IMAGE', // 이미지가 아니거나 지원 않는 형식
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
} as const
export type PhotoErrorCode = (typeof PhotoErrorCode)[keyof typeof PhotoErrorCode]
